export const categories = [
  {
    name: "常用工具",
    icon: "ri-tools-line",
    count: 168,
    desc: "在线处理类小工具集合，免安装、即开即用。",
    tags: ["格式转换", "图片压缩", "文本处理"],
    tone: "primary",
  },
  {
    name: "影视娱乐",
    icon: "ri-film-line",
    count: 132,
    desc: "追剧、观影、音乐与兴趣社区入口。",
    tags: ["在线观影", "音乐电台", "兴趣社区"],
    tone: "accent",
  },
  {
    name: "学习资源",
    icon: "ri-book-2-line",
    count: 97,
    desc: "公开课、题库、文档与技能提升站点。",
    tags: ["公开课", "题库练习", "文档资料"],
    tone: "secondary",
  },
  {
    name: "生活服务",
    icon: "ri-service-line",
    count: 84,
    desc: "缴费、办事、出行与便民查询常用入口。",
    tags: ["政务办事", "出行地图", "便民查询"],
    tone: "primary",
  },
  {
    name: "资讯阅读",
    icon: "ri-newspaper-line",
    count: 76,
    desc: "要闻速览、深度长文与垂直行业媒体。",
    tags: ["综合要闻", "深度长文", "行业观察"],
    tone: "accent",
  },
  {
    name: "数码科技",
    icon: "ri-cpu-line",
    count: 63,
    desc: "产品评测、开发者社区与极客装备入口。",
    tags: ["产品评测", "开发者社区", "开源项目"],
    tone: "secondary",
  },
  {
    name: "电商购物",
    icon: "ri-shopping-bag-3-line",
    count: 58,
    desc: "综合电商、比价工具与优惠信息聚合。",
    tags: ["综合电商", "比价工具", "优惠聚合"],
    tone: "primary",
  },
  {
    name: "效率办公",
    icon: "ri-calendar-check-line",
    count: 71,
    desc: "协作、笔记、时间管理与文档处理工具。",
    tags: ["协作办公", "云笔记", "时间管理"],
    tone: "accent",
  },
];